module.exports = __webpack_public_path__ + "static/media/note.805e8057.png";